export interface YearWording {
    difficultySuffix: string;
    difficultyDataCLabel: string;
}

export interface YearVersionConfig {
    fromYear: number;
    pathScheme: 'old' | 'new';
    wording: YearWording;
}

export const yearConfigs: YearVersionConfig[] = [
    {
        fromYear: 115,
        pathScheme: 'new',
        wording: {
            difficultySuffix: '使用AI情形',
            difficultyDataCLabel: '本階段若有使用AI，請將與AI的互動連結貼上來；無則免填',
        },
    },
    {
        fromYear: 114,
        pathScheme: 'new',
        wording: {
            difficultySuffix: '新學習',
            difficultyDataCLabel: '我們學到的新思維：',
        },
    },
    {
        fromYear: 0,
        pathScheme: 'old',
        wording: {
            difficultySuffix: '新學習',
            difficultyDataCLabel: '我們學到的新思維：',
        },
    },
];

export const getYearFromClassName = (className: string): number => {
    const match = className.match(/(\d{3})年/);
    return match ? parseInt(match[1]) : 0;
};

export const getYearConfig = (className: string): YearVersionConfig => {
    const year = getYearFromClassName(className);
    return yearConfigs.find((c) => year >= c.fromYear) ?? yearConfigs[yearConfigs.length - 1];
};
